import { __extends } from "tslib";
import cn from 'classnames';
import * as React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import { config } from '../../config';
import { url } from '../../url';
import { createDebugLogger } from '../../utils/app-utils';
import { I18nMsgNs } from '../../utils/i18n-helpers';
import { DefaultLayout } from '../Layout/DefaultLayout';
import { LayoutSegment } from '../Layout/LayoutSegment';
var _isFn = function (v) { return typeof v === 'function'; };
var debug = createDebugLogger('PageStart');
var Msg = I18nMsgNs('PageHome'); // shared test with PageHome
var PageStartClass = /** @class */ (function (_super) {
    __extends(PageStartClass, _super);
    function PageStartClass() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debug = createDebugLogger('PageStart');
        _this.onStartNewClick = function () {
            _this.props.history.replace(url.CHAT());
        };
        _this._tns = function (id, values, defaultMessage) {
            return _this.props.intl.formatMessage({ id: "PageHome.".concat(id), defaultMessage: defaultMessage }, values);
        };
        return _this;
    }
    PageStartClass.resetStatics = function () {
        PageStartClass.renderer = void 0;
        PageStartClass.rendererMain = void 0;
        PageStartClass.onInitialDataHandler = void 0;
        PageStartClass.getInitialRoute = void 0;
    };
    PageStartClass.prototype.componentDidMount = function () {
    };
    PageStartClass.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
    };
    PageStartClass.prototype.render = function () {
        var _this = this;
        var B = config.css.B('-page-home'); // share styles with page Home
        var rendererParams = {};
        var renderer = PageStartClass.renderer, rendererMain = PageStartClass.rendererMain;
        // completely external render?
        if (_isFn(renderer)) {
            return renderer(this, rendererParams);
        }
        // note: shares content with PageHome (defined in initialize-externals.tsx)
        var _renderMain = function () {
            return _isFn(rendererMain) ? (rendererMain(_this)) : (React.createElement(Button, { color: "primary", size: "lg", onClick: _this.onStartNewClick },
                React.createElement(Msg, { id: "startNew" })));
        };
        return (React.createElement(DefaultLayout, null,
            React.createElement(LayoutSegment, { label: "main" },
                React.createElement("div", { className: cn(B) }, _renderMain()))));
    };
    return PageStartClass;
}(React.Component));
export { PageStartClass };
var mapStateToProps = function (state, ownProps) {
    return {};
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return ({
        dispatch: dispatch,
    });
};
export var PageStart = withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(PageStartClass)));
export default PageStart;
